export const METRICUS_FINDING_CONTEXT_KEY = '__metricusFindingContext';

const clean = (value) => String(value ?? '').trim();

const pickFirst = (row = {}, fields = []) => {
  for (const field of fields) {
    const value = row[field];
    if (value !== undefined && value !== null && clean(value) !== '') return value;
  }
  return '';
};

export const summariseFindingObject = (row = {}, fallbackType = 'Object') => {
  const type = clean(fallbackType || row.objectType || row.type || 'Object');
  const label = pickFirst(row, [
    'metric', 'metric_name', 'name', 'title', 'description', 'finding', 'discovery_rule', 'discoveryRule',
    'step', 'transition', 'variant', 'variant_name', 'activity', 'activity_name', 'from_activity', 'to_activity',
    'status', 'label', 'key', 'id'
  ]);
  const from = pickFirst(row, ['from_activity', 'from', 'from_status', 'source']);
  const to = pickFirst(row, ['to_activity', 'to', 'to_status', 'target']);
  const transitionLabel = from && to ? `${from} → ${to}` : '';
  const variantId = pickFirst(row, ['variant_id', 'variantID', 'variant']);
  const id = pickFirst(row, ['id', 'ID', 'discovery_rule_id', 'discoveryRuleID', 'findingID']);
  const finalLabel = clean(label || transitionLabel || (variantId ? `Variant ${variantId}` : '') || (id ? `${type} ${id}` : ''));
  return { objectType: type, objectLabel: finalLabel, objectId: clean(id || variantId), row };
};

export const buildFindingContext = ({ source = '', objectType = '', objectLabel = '', objectId = '', row = null, evidence = '', title = '', category = '', filters = [], filterSummary = [] } = {}) => {
  const rowSummary = row ? summariseFindingObject(row, objectType || 'Object') : {};
  const finalObjectType = clean(objectType || rowSummary.objectType || 'Object');
  const finalObjectLabel = clean(objectLabel || rowSummary.objectLabel || '');
  const finalObjectId = clean(objectId || rowSummary.objectId || '');
  return {
    source: clean(source || 'Current view'),
    objectType: finalObjectType,
    objectLabel: finalObjectLabel,
    objectId: finalObjectId,
    title: clean(title || (finalObjectLabel ? `${finalObjectLabel} finding` : `${source || finalObjectType} finding`)),
    category: clean(category || 'Performance'),
    evidence: evidence || '',
    filters: Array.isArray(filters) ? filters : [],
    filterSummary: Array.isArray(filterSummary) ? filterSummary : [],
    row: row || rowSummary.row || null,
    updatedAt: new Date().toISOString(),
  };
};

export const setFindingContext = (context = {}) => {
  if (typeof window === 'undefined') return null;
  const next = buildFindingContext(context);
  window[METRICUS_FINDING_CONTEXT_KEY] = next;
  return next;
};

export const getFindingContext = () => {
  if (typeof window === 'undefined') return null;
  return window[METRICUS_FINDING_CONTEXT_KEY] || null;
};

export const clearFindingContext = () => {
  if (typeof window !== 'undefined') delete window[METRICUS_FINDING_CONTEXT_KEY];
};

export const setFindingContextFromGridRow = (row, source, objectType, extra = {}) => {
  const summary = summariseFindingObject(row || {}, objectType);
  return setFindingContext({ source, objectType: summary.objectType, objectLabel: summary.objectLabel, objectId: summary.objectId, row, ...extra });
};

export const openFindingForContext = (apiProvider, context = {}) => {
  const data = setFindingContext(context);
  if (apiProvider?.eventEmitter?.emit) {
    apiProvider.eventEmitter.emit('openFindingModal', { data });
  } else if (apiProvider?.openFindingModal) {
    apiProvider.openFindingModal({ data });
  }
  return data;
};
